var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "810", scrollable: "", persistent: "" },
      model: {
        value: _vm.shelfDetailsModal,
        callback: function($$v) {
          _vm.shelfDetailsModal = $$v
        },
        expression: "shelfDetailsModal"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "popup" },
        [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "modal-header-left" }, [
              _c("div", { staticClass: "modal-icon-wrap" }, [
                _c("img", {
                  staticClass: "modal-icon",
                  attrs: { src: require("@/assets/img/camera.png") }
                })
              ]),
              _c("span", { staticClass: "page-title-bar" }, [
                _vm._v(_vm._s(_vm.$t("Shelf Details")))
              ])
            ]),
            _c(
              "div",
              { staticClass: "modal-header-right" },
              [
                _c(
                  "v-chip",
                  { staticClass: "info-chip mr-2", attrs: { small: "" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Shelf")) +
                        ": " +
                        _vm._s(_vm.shelfItem.shelfId) +
                        " "
                    )
                  ]
                ),
                _c(
                  "v-chip",
                  { staticClass: "info-chip", attrs: { small: "" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Floor")) +
                        ": " +
                        _vm._s(_vm.shelfItem.floor) +
                        " "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _c("v-card-text", { staticClass: "modal-body" }, [
            _c(
              "div",
              { staticClass: "section-label mb-3" },
              [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-1",
                    attrs: { small: "", color: "#5a6a7e" }
                  },
                  [_vm._v("mdi-tune-variant")]
                ),
                _vm._v(" " + _vm._s(_vm.$t("Threshold")) + " ")
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "config-block mb-4" },
              [
                _c(
                  "div",
                  { staticClass: "block-title" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        attrs: { small: "", color: "#001e38" }
                      },
                      [_vm._v("mdi-tag-outline")]
                    ),
                    _vm._v(" " + _vm._s(_vm.$t("ESL")) + " ")
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            placeholder: _vm.$t("Input Locate ESL Threshold"),
                            label: _vm.$t("Detect Confidence"),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.esl.detConfidence,
                            callback: function($$v) {
                              _vm.$set(_vm.esl, "detConfidence", $$v)
                            },
                            expression: "esl.detConfidence"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            label: _vm.$t("Recognition Confidence"),
                            placeholder: _vm.$t("Input Locate ESL Threshold"),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.esl.recConfidence,
                            callback: function($$v) {
                              _vm.$set(_vm.esl, "recConfidence", $$v)
                            },
                            expression: "esl.recConfidence"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "config-block mb-4" },
              [
                _c(
                  "div",
                  { staticClass: "block-title" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1",
                        attrs: { small: "", color: "#001e38" }
                      },
                      [_vm._v("mdi-package-variant-closed")]
                    ),
                    _vm._v(" " + _vm._s(_vm.$t("Product")) + " ")
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            label: _vm.$t("Detect Confidence"),
                            placeholder: _vm.$t("Input Locate Product"),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.product.detConfidence,
                            callback: function($$v) {
                              _vm.$set(_vm.product, "detConfidence", $$v)
                            },
                            expression: "product.detConfidence"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            label: _vm.$t("Misplacement Threshold (MPI)"),
                            placeholder: _vm.$t(
                              "Input Misplacement Threshold: MPI"
                            ),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.product.misThreshold,
                            callback: function($$v) {
                              _vm.$set(_vm.product, "misThreshold", $$v)
                            },
                            expression: "product.misThreshold"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("v-text-field", {
                          staticClass: "form-input",
                          attrs: {
                            label: _vm.$t(
                              "Cluster Misplacement Threshold (MPI)"
                            ),
                            placeholder: _vm.$t(
                              "Input Cluster Misplacement Threshold: MPI"
                            ),
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.product.clusterMisThreshold,
                            callback: function($$v) {
                              _vm.$set(_vm.product, "clusterMisThreshold", $$v)
                            },
                            expression: "product.clusterMisThreshold"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("div", { staticClass: "config-block" }, [
              _c(
                "div",
                { staticClass: "block-title" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-1",
                      attrs: { small: "", color: "#001e38" }
                    },
                    [_vm._v("mdi-clipboard-list-outline")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("Report Settings")) + " ")
                ],
                1
              ),
              _c("div", { staticClass: "switch-row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "switch-item" },
                  [
                    _c("v-switch", {
                      staticClass: "form-switch mt-0 pt-0",
                      attrs: { inset: "", "hide-details": "", dense: "" },
                      model: {
                        value: _vm.isRestockShelf,
                        callback: function($$v) {
                          _vm.isRestockShelf = $$v
                        },
                        expression: "isRestockShelf"
                      }
                    }),
                    _c("span", { staticClass: "switch-label" }, [
                      _vm._v(_vm._s(_vm.$t("Restock Shelf")))
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "switch-item" },
                  [
                    _c("v-switch", {
                      staticClass: "form-switch mt-0 pt-0",
                      attrs: { inset: "", "hide-details": "", dense: "" },
                      model: {
                        value: _vm.reportOOS,
                        callback: function($$v) {
                          _vm.reportOOS = $$v
                        },
                        expression: "reportOOS"
                      }
                    }),
                    _c("span", { staticClass: "switch-label" }, [
                      _vm._v(_vm._s(_vm.$t("OOS Report")))
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "switch-item" },
                  [
                    _c("v-switch", {
                      staticClass: "form-switch mt-0 pt-0",
                      attrs: { inset: "", "hide-details": "", dense: "" },
                      model: {
                        value: _vm.reportMIS,
                        callback: function($$v) {
                          _vm.reportMIS = $$v
                        },
                        expression: "reportMIS"
                      }
                    }),
                    _c("span", { staticClass: "switch-label" }, [
                      _vm._v(_vm._s(_vm.$t("MIS Report")))
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "switch-item" },
                  [
                    _c("v-switch", {
                      staticClass: "form-switch mt-0 pt-0",
                      attrs: { inset: "", "hide-details": "", dense: "" },
                      model: {
                        value: _vm.reportLS,
                        callback: function($$v) {
                          _vm.reportLS = $$v
                        },
                        expression: "reportLS"
                      }
                    }),
                    _c("span", { staticClass: "switch-label" }, [
                      _vm._v(_vm._s(_vm.$t("LS Report")))
                    ])
                  ],
                  1
                )
              ])
            ])
          ]),
          _c(
            "v-card-actions",
            { staticClass: "modal-actions" },
            [
              _c(
                "v-btn",
                { staticClass: "btn", on: { click: _vm.handleDefault } },
                [_vm._v(" " + _vm._s(_vm.$t("Default")) + " ")]
              ),
              _c(
                "v-btn",
                { staticClass: "btn", on: { click: _vm.handleSave } },
                [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
              ),
              _c(
                "v-btn",
                { staticClass: "btn", on: { click: _vm.handleClose } },
                [_vm._v(" " + _vm._s(_vm.$t("Close")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }